import { useState } from "react";
import { toast } from "react-toastify";
import { useClienteLista } from "../../../hooks/queries/cliente/useClienteLista/useClienteLista";
import { Tracking } from "../../../services/Tracking";
import { useNavigate } from "react-router-dom";
import { IClienteDTO } from "../../../types/cliente";
import { useBrowserSessionStorage } from "../../../hooks/useBrowserSessionStorage";

export const useSearchClient = () => {
  const { buscarClientes } = useClienteLista();
  const [client, setClient] = useState<IClienteDTO | null>(null);
  const [, setUuidClienteAgendamento] = useBrowserSessionStorage(
    "@uuidClienteAgendamento",
  );
  const navigate = useNavigate();

  function handleContinue() {
    navigate("/agendamento/cadastro-cliente");
  }

  function handleSelect() {
    setUuidClienteAgendamento(client?.uuid || "");
    navigate("/agendamento");
  }

  const getClient = async (txt: string) => {
    return buscarClientes(txt)
      .then((data) =>
        data.content.map((item) => ({
          value: item.uuid,
          label: `${item.nome} - CPF/CNPJ: ${item.cpfCnpj}`,
          element: item,
        })),
      )
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          Tracking.error("mapa:agendamento/buscar-cliente:buscar-cliente-falhou", {
            mensagem,
          });
          toast.error(mensagem);
          return [];
        },
      );
  };

  return { getClient, client, setClient, handleContinue, handleSelect };
};
